import * as React from "react";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import styled, { useTheme, css } from "styled-components";
import { Badge } from "components/bootstrap";
import useServerText from "util/serverText";
const PriorityBadge = styled(Badge)(
  ({ bgColor = void 0, theme }) => css`
    background-color: ${bgColor};
    color: ${bgColor ? theme.utils.contrastingColor(bgColor) : void 0};
  `
);
const badgeColorByPriority = (p, threshold) => {
  if (p >= threshold) return "danger";
  if (p === threshold - 1) return "warning";
  return "default";
};
const PriorityCell = ({ priorityValue = null, priorities, showFallback = false, size = "sm" }) => {
  const { t } = useTranslation("enterprise_security_app");
  const serverText = useServerText();
  const theme = useTheme();
  const [critical, high] = useMemo(() => {
    var _a;
    if (!priorities || priorities.length === 0) {
      return [void 0, void 0];
    }
    const lastIndex = priorities.length - 1;
    return [priorities[lastIndex], (_a = priorities[lastIndex - 1]) != null ? _a : priorities[lastIndex]];
  }, [priorities]);
  const priorityText = useMemo(
    () => {
      var _a;
      return serverText((_a = priorities == null ? void 0 : priorities.find((priority) => priority.priority === priorityValue)) == null ? void 0 : _a.text) || null;
    },
    [priorities, priorityValue, serverText]
  );
  const title = useMemo(() => {
    const text = priorityText != null ? priorityText : priorityValue;
    if (priorityValue === (critical == null ? void 0 : critical.priority)) return String(text).toUpperCase();
    return text;
  }, [critical == null ? void 0 : critical.priority, priorityText, priorityValue]);
  if (priorityValue === null || priorityValue === void 0 || priorityValue === 0) {
    return showFallback ? /* @__PURE__ */ React.createElement("i", null, t("priority_cell.no_priority")) : null;
  }
  const variant = (high == null ? void 0 : high.priority) ? badgeColorByPriority(priorityValue, high.priority) : "default";
  const isHighPriority = (high == null ? void 0 : high.priority) && priorityValue >= (high == null ? void 0 : high.priority) && priorityValue !== (critical == null ? void 0 : critical.priority);
  const color = isHighPriority ? theme.colors.variant.light.danger : void 0;
  return /* @__PURE__ */ React.createElement(
    PriorityBadge,
    {
      bsSize: size,
      bgColor: color,
      bsStyle: variant,
      title: t("priority_cell.title", { text: priorityText })
    },
    title
  );
};
export default PriorityCell;
